import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, vShow as _vShow, withDirectives as _withDirectives, createTextVNode as _createTextVNode, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5791bdb6"),n=n(),_popScopeId(),n)
const _hoisted_1 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_3 = { class: "statelist-error-table" }
const _hoisted_4 = { key: 1 }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_date_picker_modal_component = _resolveComponent("date-picker-modal-component")!
  const _component_CTable = _resolveComponent("CTable")!
  const _component_CSpinner = _resolveComponent("CSpinner")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createTextVNode(" Statelista dla "),
    _createElementVNode("span", null, "WEA" + _toDisplayString(_ctx.$route.params.id), 1),
    _hoisted_1,
    _createVNode(_component_date_picker_modal_component, { onPickedDates: _ctx.fetchFromPickedDate }, null, 8, ["onPickedDates"]),
    _hoisted_2,
    _withDirectives(_createElementVNode("div", _hoisted_3, [
      (!_ctx.turbine.noErrors)
        ? (_openBlock(), _createBlock(_component_CTable, {
            key: 0,
            striped: "",
            columns: _ctx.columns,
            items: _ctx.turbine.errors
          }, null, 8, ["columns", "items"]))
        : (_openBlock(), _createElementBlock("p", _hoisted_4, _toDisplayString(_ctx.msg), 1))
    ], 512), [
      [_vShow, _ctx.isLoaded]
    ]),
    _withDirectives(_createVNode(_component_CSpinner, {
      color: "success",
      class: "spinner"
    }, null, 512), [
      [_vShow, !_ctx.isLoaded]
    ])
  ], 64))
}